(function() {
    'use strict';

    angular
        .module('app.ordenes')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/ordenes',
                config: {
                    templateUrl: 'app/ordenes/list.html',
                    controller: 'ordenes.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-orden/:id?',
                config: {
                    templateUrl: 'app/ordenes/edit.html',
                    controller: 'ordenes.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            },
            {
                url: '/firmar-orden/:id',
                config: {
                    templateUrl: 'app/ordenes/firmar.html',
                    controller: 'ordenes.Firmar',
                    controllerAs: 'vm',
                    title: 'Firmar'
                }
            },
            {
                url: '/anular-orden/:id',
                config: {
                    templateUrl: 'app/ordenes/anular.html',
                    controller: 'ordenes.Anular',
                    controllerAs: 'vm',
                    title: 'Anular'
                }
            }
        ];
    }
})();
